var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2246 12.6C16.9676 12.6 18.3746 14.007 18.3746 15.75C18.3746 17.493 16.9676 18.9 15.2246 18.9C13.4816 18.9 12.0746 17.493 12.0746 15.75C12.0746 15.498 12.1061 15.267 12.1691 15.0255L7.57011 12.6105C6.99261 13.251 6.17361 13.65 5.24961 13.65C3.50661 13.65 2.09961 12.243 2.09961 10.5C2.09961 8.75698 3.50661 7.34998 5.24961 7.34998C6.17361 7.34998 6.99261 7.75948 7.57011 8.38947L12.1691 5.97448C12.1061 5.73298 12.0746 5.50198 12.0746 5.24998C12.0746 3.50698 13.4816 2.09998 15.2246 2.09998C16.9676 2.09998 18.3746 3.50698 18.3746 5.24998C18.3746 6.99298 16.9676 8.39998 15.2246 8.39998C14.3006 8.39998 13.4816 7.99048 12.9041 7.36048L8.30511 9.77548C8.43209 10.2501 8.43209 10.7498 8.30511 11.2245L12.9041 13.6395C13.4816 12.999 14.3006 12.6 15.2246 12.6Z",
    fill: "#1447DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.38bf860a2289e479ebdd947e9e338c67.svg";
export { ForwardRef as ReactComponent };